import React from 'react';
import { ShieldCheckIcon, LockIcon, DatabaseIcon } from 'lucide-react';
export function TrustStrip() {
  return <section className="py-12 bg-slate-100 border-y border-slate-200" data-id="element-243">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 text-center md:text-left" data-id="element-245">
          <div className="flex items-center gap-4" data-id="element-246">
            <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-green-600" data-id="element-247">
              <ShieldCheckIcon className="w-6 h-6" data-id="element-248" />
            </div>
            <div data-id="element-249">
              <h4 className="font-bold text-heading" data-id="element-250">Enterprise Grade</h4>
              <p className="text-sm text-slate-500" data-id="element-251">Built for institutions</p>
            </div>
          </div>

          <div className="hidden md:block w-px h-12 bg-slate-300" data-id="element-252"></div>

          <div className="flex items-center gap-4" data-id="element-253">
            <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-primary" data-id="element-254">
              <DatabaseIcon className="w-6 h-6" data-id="element-255" />
            </div>
            <div data-id="element-256">
              <h4 className="font-bold text-heading" data-id="element-257">
                Local Server Deployment
              </h4>
              <p className="text-sm text-slate-500" data-id="element-258">100% on-premise control</p>
            </div>
          </div>

          <div className="hidden md:block w-px h-12 bg-slate-300" data-id="element-259"></div>

          <div className="flex items-center gap-4" data-id="element-260">
            <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-slate-700" data-id="element-261">
              <LockIcon className="w-6 h-6" data-id="element-262" />
            </div>
            <div data-id="element-263">
              <h4 className="font-bold text-heading" data-id="element-264">Data Privacy</h4>
              <p className="text-sm text-slate-500" data-id="element-265">Secure by design</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}